import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeToDate'
})
export class TimeToDatePipe implements PipeTransform {
  transform(value: number): Date | Date[] {
    if (typeof value === 'number') return new Date(value);
    return null;
  }
}
